export const AIRWALLEX_CONFIG = {
  PROD_CLIENT_ID: '5MmrPisDSZWwHSLfav9kqw' as const,
  DEV_CLIENT_ID: '0J0DMEJfSrm-rUr80Cfk5Q' as const,
  PROD_ENV: 'prod' as const,
  DEV_ENV: 'demo' as const,
  LOCALE: 'en' as const,
  ENABLED_ELEMENTS: ['risk', 'payouts'] as const,
} as const
